import { VERIFICATION_REPORT } from '@clearverify/constants';
import { Nullable } from '@clearverify/types';

import { ActivityLogType, User, VerificationRequestType } from 'src/api';
import { BusinessRole } from 'src/constants/user';
import { hasOneOfRoles } from 'src/utils/role';
import { getUserFullName } from 'src/utils/user';

export const getCommentHeading = (user: User): string => {
  const userFullName = getUserFullName(user);

  if (hasOneOfRoles(user.employerStaff, [BusinessRole.Employee])) {
    return `Employee ${userFullName} added comment`;
  }

  if (
    hasOneOfRoles(user.verifierStaff, [BusinessRole.VerifierAdmin, BusinessRole.VerifierManager])
  ) {
    return `Verifier ${userFullName} added comment`;
  }

  return `${userFullName} added comment`;
};

export const getActivityLogHeading = (activityType: ActivityLogType): string => {
  if (activityType === ActivityLogType.Sent) {
    return `sent Verification Report on Email`;
  }

  if (activityType === ActivityLogType.Viewed) {
    return `Viewed`;
  }

  return `Viewed`;
};

export const getBlockInformationHeading = (reportType: Nullable<VerificationRequestType>) => {
  if (!reportType) return `${VERIFICATION_REPORT} `;

  if (reportType === VerificationRequestType.VerificationOfEmployment) {
    return 'Employment Verification Report ';
  }
  return 'Income Verification Report ';
};
